import { useImperativeHandle } from 'react'
import { useForm } from 'react-hook-form'

const useRoleForm = function ({ currentRole = {} }, ref) {
  const {
    control,
    register,
    formState: { errors },
    formState,
    getValues,
    trigger,
    clearErrors,
    reset,
  } = useForm({
    defaultValues: currentRole,
  })

  if (ref) {
    useImperativeHandle(ref, () => ({
      getValues,
      trigger,
    }))
  }

  return {
    control,
    register,
    formState,
    errors,
    clearErrors,
    reset,
  }
}

export default useRoleForm
